<div class="tooglenav">
  
  <div class="linksec">
    
  <div class="mainLabel">
    Management <mat-icon>expand_more</mat-icon>
  </div>


  <ng-container>
    <div class="sublist">
      <a routerLinkActive="active-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
        (click)="openOrg()">
        All Organization
      </a>
    </div>
  </ng-container>
  </div>



  <div class="linksec">
    <div class="mainLabel">
      Admin <mat-icon>expand_more</mat-icon>
    </div>
  
    <ng-container>
      <div class="sublist">
        <a *ngIf="showUser" routerLinkActive="active-link" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}" [routerLink]="'/admin'">
          Users
        </a>
  
        <a *ngIf="showPermission" routerLinkActive="active-link" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}" [routerLink]="'permissions'">
          Permissions
        </a>
  
        <a *ngIf="showRole" routerLinkActive="active-link" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}" [routerLink]="'role'">
          Roles
        </a>
  
        <!-- <a *ngIf="showOrganization" routerLinkActive="active-link" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}" [routerLink]="'organization'">
          Organization
        </a> -->
  
        <a *ngIf="showModule" routerLinkActive="active-link" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}" [routerLink]="'module'">
          Module
        </a>
  
      </div>
    </ng-container>
  
  
  </div>
  

  <div class="linksec" *ngIf="showLoginDetails">    
    <div class="mainLabel">
      All Login Details <mat-icon>expand_more</mat-icon>
    </div>  
  
    <ng-container>
      <div class="sublist">
        <a routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}" [routerLink]="'logindetails'">
         Login Details
        </a>
      </div>
    </ng-container>
    </div>


</div>